import Vue from 'vue'
import FavoritesAPI from '@/api/favourites'
import Pagination from '../../../models/PaginationClass'
import { favourites as mutations } from '../../types/mutation-types'
import { favourites as actions } from '../../types/action-types'
import Article from '../../../models/ArticleClass'

export default {
  namespaced: true,
  state: {
    loading: false,
    collection: [],
    pagination: new Pagination()
  },

  getters: {
    loading: state => state.loading,
    collection: state => state.collection,
    pagination: state => state.pagination
  },

  mutations: {
    [mutations.FAVOURITES_REQUEST](state) {
      state.loading = true
    },
    [mutations.FAVOURITES_SUCCESS](state, { articles, pagination }) {
      state.loading = false
      Vue.set(state, 'collection', articles)
      Vue.set(state, 'pagination', pagination)
    },
    [mutations.FAVOURITES_ERROR](state) {
      state.loading = false
      state.collection = []
    },
    [mutations.FAVOURITES_PUSH_ITEM](state, article) {
      state.collection.unshift(article)
      Vue.set(state, 'collection', state.collection)
    },
    [mutations.FAVOURITES_DELETE](state, articleId) {
      const index = state.collection.findIndex(a => a.id === articleId)
      if (index !== -1) Vue.delete(state.collection, index)
      state.loading = false
    }
  },

  actions: {
    /**
     * Get favourites (paginated)
     * @param {*} context
     * @param {{ type: string, page?: number, per_page?: number }} payload
     */
    async [actions.FAVOURITES_GET](context, { type, page = 1, per_page = 9 }) {
      context.commit(mutations.FAVOURITES_REQUEST)

      const _type = context.rootState.favourites.types[type.toString().toUpperCase()]
      try {
        const res = await FavoritesAPI.get(_type, page, per_page)

        const articles = []
        for (const item of res.data.data || []) {
          if (item.object) {
            articles.push(new Article(item.object))
          }
        }

        const pagination = new Pagination({
          total: res.data.total || 0,
          last_page: res.data.last_page || 1,
          per_page: res.data.per_page || per_page,
          current_page: res.data.current_page || page
        })

        context.commit(mutations.FAVOURITES_SUCCESS, { articles, pagination })
      } catch (err) {
        context.commit(mutations.FAVOURITES_ERROR)
        console.error('Pagination Fetch Error:', err.response.data || err.message)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/favourites/articles.js